import React from 'react'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { loginRequest } from './authConfig'

export const UnauthenticatedPage = () => {
	const { instance } = useMsal()
	const isAuthenticated = useIsAuthenticated()
	if(!isAuthenticated){
		instance.loginRedirect(loginRequest).catch((e) => {
			console.log(e)
		})
	}
	

	return <div>Redirect for Login.....</div>
}
